<template>
  <div>
    <div class="dialog-add-account__form-title">
      {{ $t('business_account_data.closing_doc') }}
    </div>

    <div class="dialog-add-account__form-block">
      <div class="dialog-add-account__form-row">
        <div class="dialog-add-account__form-col dialog-add-account__form-col--big">
          <div class="dialog-add-account__form-item">
            <div
              class="form-input"
              :class="[
                { 'form-input--full': value.method !== 'not_receive' },
                { 'form-input--error': docErrors.method },
              ]"
            >
              <select
                :value="value.method"
                required
                :disabled="disabled"
                @change="handleMethodChange($event.target.value)"
              >
                <option disabled>{{ $t('business_account_data.choose_op') }}</option>
                <option value="in_office">{{ $t('business_account_data.edo') }}</option>
                <option value="by_email">{{ $t('business_account_data.byemail') }}</option>
              </select>

              <span class="form-input__label">
                {{
                  value.method !== 'not_receive'
                    ? $t('business_account_data.get_orig')
                    : $t('business_account_data.vay_to_get_orig')
                }}
              </span>
              <div v-if="docErrors.method" class="form-input__error" v-text="docErrors.method" />
            </div>
          </div>
        </div>

        <!-- Поля для почтового адреса (показываются только при выборе by_email) -->
        <template v-if="value.method === 'by_email'">
          <div class="dialog-add-account__form-col">
            <div class="dialog-add-account__form-item">
              <div
                class="form-input"
                :class="[
                  { 'form-input--full': value.mail_index },
                  {
                    'form-input--error':
                      docErrors.mail_index ||
                      (serverErrors && serverErrors.legal_receiving_mail_index),
                  },
                ]"
              >
                <input
                  :value="value.mail_index"
                  type="text"
                  required
                  :disabled="disabled"
                  @input="handleFieldChange('mail_index', $event.target.value)"
                />
                <span class="form-input__label">{{ $t('business_account_data.index') }}</span>
                <div
                  v-if="docErrors.mail_index"
                  class="form-input__error"
                  v-text="docErrors.mail_index"
                />
                <div
                  v-if="serverErrors && serverErrors.legal_receiving_mail_index"
                  class="form-input__error"
                >
                  <p v-for="(err, index) in serverErrors.legal_receiving_mail_index" :key="index">
                    {{ err }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="dialog-add-account__form-col">
            <div class="dialog-add-account__form-item">
              <div
                class="form-input"
                :class="[
                  { 'form-input--full': value.mail_recipient },
                  { 'form-input--error': docErrors.mail_recipient },
                ]"
              >
                <input
                  :value="value.mail_recipient"
                  type="text"
                  required
                  :disabled="disabled"
                  @input="handleFieldChange('mail_recipient', $event.target.value)"
                />
                <span class="form-input__label">{{ $t('business_account_data.receiver') }} </span>
                <div
                  v-if="docErrors.mail_recipient"
                  class="form-input__error"
                  v-text="docErrors.mail_recipient"
                />
              </div>
            </div>
          </div>

          <div class="dialog-add-account__form-col dialog-add-account__form-col--big">
            <div class="dialog-add-account__form-item">
              <div
                class="form-input"
                :class="[
                  { 'form-input--full': value.mail_address },
                  {
                    'form-input--error':
                      docErrors.mail_address ||
                      (serverErrors && serverErrors.legal_receiving_mail_address),
                  },
                ]"
              >
                <input
                  :value="value.mail_address"
                  type="text"
                  required
                  :disabled="disabled"
                  @input="handleFieldChange('mail_address', $event.target.value)"
                />
                <span class="form-input__label">{{ $t('business_account_data.address') }}</span>
                <div
                  v-if="docErrors.mail_address"
                  class="form-input__error"
                  v-text="docErrors.mail_address"
                />
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentReceivingSettings',
  props: {
    value: {
      type: Object,
      required: true,
      validator: (value) => {
        return 'method' in value;
      },
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    serverErrors: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    docErrors() {
      return {
        method: this.errors.legal_receiving_docs_method || '',
        mail_index: this.errors.legal_receiving_mail_index || '',
        mail_recipient: this.errors.legal_receiving_mail_recipient || '',
        mail_address: this.errors.legal_receiving_mail_address || '',
      };
    },
  },
  methods: {
    handleMethodChange(newMethod) {
      const updated = { ...this.value, method: newMethod };
      this.$emit('input', updated);
    },
    handleFieldChange(field, newValue) {
      const updated = { ...this.value, [field]: newValue };
      this.$emit('input', updated);
    },
  },
  emits: ['input'],
};
</script>
